module.exports = __webpack_public_path__ + "media/images/metronic/portlet-minus-icon-white-60b201d43205ae56edcbb40440f6ea44.png";